import styled from 'styled-components';
import {theme} from './../../../styles/theme'

interface ResponsiveProps {
  isMobileMini?: boolean;
  isMobileMedium?: boolean;
  isMobileBig?: boolean;
  isMiniNotebook?: boolean;
}

interface RightScanWrapperProps extends ResponsiveProps {
  isCollapsed: boolean;
  width: string;
}

export const RightScanWrapper = styled.div<RightScanWrapperProps>`
  padding-top: 75px;
  position: fixed;
  right: 0; /* Fixa o RightScan na lateral direita */
  top: 0;
  width: ${(props) => (props.isCollapsed ? "18px" : props.width)};
  height: 100%; /* Altura total da tela */
  transition: width 0.3s ease;
  background: ${(props) => (props.isCollapsed ? "transparent" : "#FAFEE8")};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-shadow: ${(props) => (props.isCollapsed ? "none" : "-5px 0 10px rgba(0, 0, 0, 0.2)")};
  //box-shadow: -5px 0 10px rgba(0, 0, 0, 0.2); /* Sombra para destacar sobreposição */
  z-index: 8; /* Garante que fique sobre o conteúdo */
`;

export const TitleLogo = styled.p<ResponsiveProps>`
   font-size: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '25px' : isMobileMedium ? '25px' : isMobileBig ? '35px' : '35px' };
    color: ${({theme })=> theme.colors.primaryDark};
  margin-left: 25px;
  font-family: "MySatisfy", Sans-serif;
  font-weight: bold;
`

export const ToggleText = styled.span<{ isCollapsed: boolean }>`
  color: ${({ isCollapsed }) => (isCollapsed ? "#a36751" : "#a36751")}; /* Verde quando fechado, vermelho quando aberto */
  font-weight: bold;
  margin-top: 6px;
`;


export const SectionPosts = styled.section`
  background-color: trasparent;
  margin-left: 24px;
`;

export const ToggleButton = styled.button`
  position: absolute;
  left: 0; /* Para que o botão fique na borda esquerda do RightScan */
  top: 50%;
  transform: translateY(-50%) rotate(0); /* Gira o texto corretamente */
  width: 18px;
  height: 110px;
  background-color: ${({theme })=> theme.colors.primary};
  color: white;
  border: none;
  cursor: pointer;
  font-size: 12px;
  writing-mode: vertical-rl;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
`;


export const PostList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  li {
    margin: 5px 0;
  }
  a {
    text-decoration: none;
    color: ${({theme })=> theme.colors.primaryDark};
    display: block;
    padding: 5px;
    &:hover {
      background: #ddd;
    }
  }
`;

export const TitleSection = styled.h3<ResponsiveProps>`
  color: ${({theme })=> theme.colors.primaryDark};
  font-size: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '14px' : isMobileMedium ? '14px' : isMobileBig ? '20px' : '20px' };
`;

export const MonthSection = styled.div`
  margin-top: 10px;
  width: 100%;
`;

export const ItemLink = styled.a<ResponsiveProps>`
  cursor: "pointer";
  color: ${({theme })=> theme.colors.primaryDark};
  font-size: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '12px' : isMobileMedium ? '12px' : isMobileBig ? '14px' : '14px' };
`

export const MonthTitle = styled.div<ResponsiveProps>`
  font-weight: bold;
  font-size:  ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '13px' : isMobileMedium ? '13px' : isMobileBig ? '18px' : '18px' };
  color: ${({theme })=> theme.colors.naviLinkColor};
  cursor: pointer;
  padding: 5px 5px 5px 15px;
  border-radius: 10px;
  background: ${({theme })=> theme.colors.primaryDark};
  &:hover {
    background: ${({theme })=> theme.colors.primaryDark};
  }
`;